// extracted by mini-css-extract-plugin
module.exports = {"tag_quantity":"styles_tag_quantity__1qcXT","tag":"styles_tag__eOcXj","tag_mv2":"styles_tag_mv2__MRr7b"};